import React from 'react';

const PrimeroSegundo = () => {
    return (
        <div className='seccion'>		
        	
            <h1>PROGRAMAS DE ESTUDIOS - 2023</h1>

            <h4>Materias Plan Institucional - 1er y 2do año</h4>	
        
        <div className="contenedor-tablas">
        <table className="tabla-programas">
            <caption>1er Año</caption>
            <tr>

                <th>Materia</th>
                <th>Programa</th>

            </tr>
            <tr>

<td>Biologia</td>
<td><a href="https://drive.google.com/drive/folders/1myMozgTEe6aLhIV6SNhg-8Whiunue5O0?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Contabilidad</td>
<td><a href="https://drive.google.com/drive/folders/1bP4Je2B8SeBiVLY7ZuBsEqP0_w3qd-Tj?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Cs. Biologicas</td>
<td><a href="https://drive.google.com/drive/folders/1zXU5NAD-5mmx1-vkL68GfQDCknFF3a7R?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Ed. Civica</td>
<td><a href="https://drive.google.com/drive/folders/1s75ddF8rp8gan6qjSu0ttpb8MJqeuNlN?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Geografia</td>
<td><a href="https://drive.google.com/drive/folders/17l-moGYXjNBm-7KWmAGhw_BjFdyRN7bL?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Historia</td>
<td><a href="https://drive.google.com/drive/folders/1menSpFmmZC5PoIeyzkhA_SvwwA5xVFeA?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Ingles</td>
<td><a href="https://drive.google.com/drive/folders/1_awCvRsw9845m3QMlZ5OOB0J-fRbo9iR?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Introd. al Derecho</td>
<td><a href="https://drive.google.com/drive/folders/1Vr7Flp03eyWiaGzO_d1YulODgPDuE4ii?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Lengua</td>
<td><a href="https://drive.google.com/drive/folders/1nU2lmOm2Dh7KDiZcZIix4Zt5KgvLhl9E?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Matematica</td>
<td><a href="https://drive.google.com/drive/folders/1Mfes-xxRehK-KonIUphWv1-YMVrBJvDd?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

<tr>

<td>Tec. Mercantil</td>
<td><a href="https://drive.google.com/drive/folders/1Nyb2p1eDIPjbqhHBbgEhsGGrKentoMfx?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

</tr>

        </table>
        <table className="tabla-programas">
            <caption>2do Año</caption>
            <tr>

                <th>Materia</th>
                <th>Programa</th>

            </tr>
				<tr>

					<td>Biologia</td>
					<td><a href="https://drive.google.com/drive/folders/1-QMfonY-5aDpC9xQvpUHDEBKkhcPh85g?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Contabilidad</td>
					<td><a href="https://drive.google.com/drive/folders/18qZbKF2ChonNR8124llyHmQAWFg0Ce1R?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ed. Civica</td>
					<td><a href="https://drive.google.com/drive/folders/1guDPy-50wuFtETTht4MRGAdwSwWxPKD5?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Geografia</td>
					<td><a href="https://drive.google.com/drive/folders/1br2_Rxf4NJVzPAXffKVv8vTT7JBdUTjq?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ingles</td>
					<td><a href="https://drive.google.com/drive/folders/1PxQ1zPhZu26EiQaiyR-EjGmjUUegpWCV?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Int. Derecho</td>
					<td><a href="https://drive.google.com/drive/folders/1_d9Ke6SBsd0x0h0XKxBzrZZN2DCj8k2W?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Lengua</td>
					<td><a href="https://drive.google.com/drive/folders/10t36k5pKY6Vr0f8gkzAHoGB6d-ef9WDh?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Matematica</td>
					<td><a href="https://drive.google.com/drive/folders/1O6SDE9kEYK6SWn-ZIiPD2gXTKA7JTNPe?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Tec. Mercantil</td>
					<td><a href="https://drive.google.com/drive/folders/1xQhq9BUz2OhVu3okY7Jpz6gRKQG303k4?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>


        </table>
    </div>
            
        </div>
    );
}

export default PrimeroSegundo;
